<template>
    <div>
        <el-form :model="info" :rules="rules" ref="ruleForm" label-width="150px" style="width:700px;">
            <el-form-item label="是否标准" prop="isStandard">
                <div v-if="type != 'edit'">
                    <div  v-for="item in standards" :key="item.id">
                    <el-radio v-if="item.platform_filter.indexOf($platform) > -1"
                        @change="isStandardChange"
                        v-model="info.isStandard"
                        :label="item.id">
                            {{item.name}}
                    </el-radio>

                    </div>

                </div>
                <label v-else class="info-label">
                    {{info.isStandardName}}
                </label>
            </el-form-item>
            <el-form-item label="设置适用卡模板/活动" prop="templateActivityShow">
                <!-- 模板 -->
                <div class="cards-template-wapper" v-if="info.isStandard == 1">
                    <div class="cards-template-item">
                        <el-select placeholder="请选择主模板"
                            v-model="currMainTemplateId"
                            @change="mainTemplateChange">
                            <el-option
                                v-for="item in mainTemplates"
                                :key="item.id"
                                :label="item.templateName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="cards-template-item">
                        <el-select placeholder="请选择子模板" v-model="currTemplateId">
                            <el-option
                                v-for="item in templates"
                                :key="item.id"
                                :label="item.templateName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button size="small" @click="addTemplate">添加</el-button>
                    <div class="selected-wapper">
                        <ul>
                            <li v-for="(item, index) in info.templateActivityShow" :key="index">
                                <span class="selected-title">适用模板{{index + 1}}</span>
                                <span class="selected-name">{{item.templateName}}</span>
                                <el-button type="text" size="small" @click="removeTemplate(index)">删除</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 活动 -->
                <div class="cards-template-wapper" v-if="info.isStandard == 2 || info.isStandard == 3">
                    <div class="cards-template-item" v-if="info.isStandard == 2">
                        <el-select placeholder="请选择活动" v-model="currActivityId" filterable>
                            <el-option
                                v-for="item in activitys"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="cards-template-item" v-if="info.isStandard == 3">
                        <el-select placeholder="请选择活动" v-model="currActivityId" filterable>
                            <el-option
                                v-for="item in welfares"
                                :key="item.id"
                                :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button size="small" @click="addActivity">添加</el-button>
                    <div class="selected-wapper">
                        <ul>
                            <li v-for="(item, index) in info.templateActivityShow" :key="index">
                                <span class="selected-title">适用活动{{index + 1}}</span>
                                <span class="selected-name">{{item.activityName}}</span>
                                <el-button type="text" size="small" @click="removeActivity(index)">删除</el-button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="notes">注：建议模板和提成方案进行一对一关联设置。</div>
            </el-form-item>
            <!-- 发票内容 -->
            <el-form-item label="" prop="invoiceList">
                <div class="label-title">请在以下列表中选择该提成方案下对应模板的可开的发票内容</div>
                <div class="i-content-wapper">
                    <div class="i-content-query">
                        <el-input placeholder="请输入发票内容名称或关键字" v-model="contentName" style="width:300px;"></el-input>
                        <el-button size="small" @click="getInvoiceListByName">查询</el-button>
                    </div>
                    <el-table :data="invoiceContents" @select="tableSelect" @select-all="tableSelect" ref="invoiceContents">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="name" label="发票内容名称"></el-table-column>
                    </el-table>
                </div>
                <div class="notes">注：建议模板和提成方案进行一对一关联设置。</div>
            </el-form-item>
            <el-form-item label="备注说明" prop="remarks">
                <el-input type="textarea" placeholder="请输入提成方案备注信息说明字" rows="5" resize="none" v-model="info.remarks"></el-input>
            </el-form-item>
        </el-form>
        <div class="button-wapper">
            <el-button size="small" type="primary" @click="_submit">提交</el-button>
        </div>
    </div>
</template>

<script>
    import _royaltyPlan from '@/service/royalty-plan-service'
    import _activity from '@/service/activity-service'
    import _template from '@/service/template-service'
    import _invoiceContent from '@/service/invoice-content-service'
    import _welfare from '@/service/welfare-service'
    import _constant from '@/utils/constant'
    export default {
        data() {
            return {
                type: this.$route.query.type,
                // 活动列表
                activitys: null,
                currActivityId: null,
                // 主模板列表
                mainTemplates: null,
                currMainTemplateId: null,
                // 子模板列表
                templates: null,
                currTemplateId: null,
                // 发票内容
                invoiceContents: [],
                contentName: null,
                // 是否标准
                standards: null,
                // 福利兑换
                welfares: null,
                info: {
                    planId: this.$route.query.id,
                    isStandard:1,
                    remarks: null,
                    templateList: [],
                    activityList: [],
                    invoiceList: [],
                    // 活动模板展示列表
                    templateActivityShow: []
                },
                rules: {
                    isStandard: [
                        { required: true, message: '请选择是否标准', trigger: 'submit' }
                    ],
                    templateActivityShow: [
                        { required: true, message: '请设置模板/活动', trigger: 'submit' }
                    ],
                    invoiceList: [
                        { required: true, message: '请选择发票内容', trigger: 'submit' }
                    ]
                }
            }
        },
        mounted () {
            // 查询是否标准
            // _welfare.getIsStandardList(response => {
            //     this.standards = response
            // })
            this.standards  = _constant.standardList
            // if (this.info.planId == null || this.info.planId == undefined) {
            //     this.$router.push({
            //         path: '/add-royalty-plan'
            //     })
            // }
            // 查询福利兑换活动列表
            _welfare.getIdTitleAllWelfare(response => {
                this.welfares = response
            })
            // 查询活动列表
            _activity.getIdTitleAll(response => {
                this.activitys = response
            })
            // 查询主模板列表
            _template.getMainTemplateAll('', response => {
                this.mainTemplates = response
            })
            // 发票内容列表
            this.getInvoiceListByName(() => {
                if (this.info.planId != null && this.type == 'edit') {
                    let _loading = this.$loading({ fullscreen: true })
                    _royaltyPlan.royaltyPlanDetalis(this.info.planId, response => {
                        _loading.close()
                        this.info = response
                        this.info.templateActivityShow = []
                        if (this.info.isStandard == 1) {
                            this.info.templateList.forEach(item => {
                                this.info.templateActivityShow.push(item)
                            })
                        } else {
                            this.info.activityList.forEach(item => {
                                this.info.templateActivityShow.push(item)
                            })
                        }
                        // 选中已选发票内容
                        for (const content of this.invoiceContents) {
                            for (const item of this.info.invoiceList) {
                                if (item.invoiceContentId == content.id) {
                                    console.log(content, 'content');

                                    this.$refs.invoiceContents.toggleRowSelection(content)
                                }
                            }
                        }
                    })
                }
            })
        },
        methods: {
            goBack () {
                this.$router.back()
            },
            // 发票内容查询
            getInvoiceListByName (callBack) {
                this.invoiceContents = null
                _invoiceContent.getInvoiceListByName(this.contentName, response => {
                    this.invoiceContents = response
                    typeof callBack === 'function' && callBack()
                })
            },
            // 表格多选事件
            tableSelect (selection) {
                this.info.invoiceList = []
                selection.forEach(item => {
                    this.info.invoiceList.push({
                        invoiceContentId: item.id
                    })
                })
            },
            isStandardChange () {
                this.info.templateList = []
                this.info.activityList = []
                this.info.templateActivityShow = []
                this.currActivityId = null
                this.currTemplateId = null
                this.$set(this.info, this.info.templateActivityShow)
            },
             // 主模板改变查询子模板
            mainTemplateChange () {
                this.templates = null
                this.currTemplateId = null
                _template.getTemplateAll(this.currMainTemplateId, response => {
                    this.templates = response
                })
            },
            // 添加活动
            addActivity () {
                if (this.currActivityId == null) {
                    this.$notify({
                        message: '请选择活动',
                        type: 'warning'
                    });
                    return
                }
                // 判断是否包含
                for (const item of this.info.activityList) {
                    if (item.activityId == this.currActivityId) {
                        this.$notify({
                            message: '该活动已添加',
                            type: 'warning'
                        });
                        return
                    }
                }
                if (this.info.isStandard == 2) {
                    this.activitys.forEach((item) => {
                        if (this.currActivityId == item.id) {
                            this.info.activityList.push({
                                activityId: item.id
                            })
                            this.info.templateActivityShow.push({
                                activityId: item.id,
                                activityName: item.title
                            })
                            this.currActivityId = null
                        }
                    })
                }
                if (this.info.isStandard == 3) {
                    this.welfares.forEach((item) => {
                        if (this.currActivityId == item.id) {
                            this.info.activityList.push({
                                activityId: item.id
                            })
                            this.info.templateActivityShow.push({
                                activityId: item.id,
                                activityName: item.title
                            })
                            this.currActivityId = null
                        }
                    })
                }
            },
            // 删除活动
            removeActivity (index) {
                this.info.activityList.splice(index, 1)
                this.info.templateActivityShow.splice(index, 1)
                this.$set(this.info, this.info.templateActivityShow)
            },
            // 添加模板
            addTemplate () {
                if (this.currTemplateId == null) {
                    this.$notify({
                        message: '请选择子模板',
                        type: 'warning'
                    });
                    return
                }
                // 判断是否包含
                for (const item of this.info.templateList) {
                    if (item.templateId == this.currTemplateId) {
                        this.$notify({
                            message: '该子模板已添加',
                            type: 'warning'
                        });
                        return
                    }
                }
                this.templates.forEach((item) => {
                    if (this.currTemplateId == item.id) {
                        this.info.templateList.push({
                            templateId: item.id,
                            parentTemplateId: this.currMainTemplateId
                        })
                        this.info.templateActivityShow.push(item)
                        this.currTemplateId = null
                    }
                })
            },
            // 删除模板
            removeTemplate (index) {
                this.info.templateList.splice(index, 1)
                this.info.templateActivityShow.splice(index, 1)
                this.$set(this.info, this.info.templateActivityShow)
            },
            // 提交
            submit (id) {
                this.$refs.ruleForm.validate((valid) => {
                    if (!valid) {
                        this.$notify({ message: '有必填项未填写，请检查后再提交', type: 'warning' })
                        this.$emit('closeDialog')
                        return false
                    }
                    let _loading = this.$loading({ fullscreen: true })
                    // 提交请求
                    if (this.type == 'edit') {
                        this.info.planId = this.info.id
                        _royaltyPlan.planSecondEdit(this.info, (res) => {
                            _loading.close()
                            this.$notify({
                                message: '修改成功',
                                type: 'success'
                            })
                            this.$router.push({
                                path: '/royalty-plan-detail',
                                query:{
                                    id:this.info.id,
                                    status:1,
                                }
                            })
                        }, response => {
                            _loading.close()
                            this.$emit('closeDialog')
                            this.$notify({
                                message: response,
                                type: 'warning'
                            })
                        })
                    } else {
                        this.info.planId = id
                        _royaltyPlan.planSecondAdd(this.info, (res) => {
                            _loading.close()
                            this.$notify({
                                message: '创建成功',
                                type: 'success'
                            })
                            this.$router.push({
                                path: '/royalty-plan-detail',
                                query:{
                                    id:id,
                                    status:1,
                                }
                            })
                        }, response => {
                            _loading.close()
                            this.$notify({
                                message: response,
                                type: 'warning'
                            })
                        })
                    }
                })
            },
            _submit(){
                this.$emit('submit')
            },
        }
    }
</script>

<style scoped>
.wapper {
    padding: 15px;
}
.header{
    margin-bottom: 15px;
}
.content-wapper{
    border: 1px solid #d6dbe5;
    border-radius: 3px;
    padding: 15px;
    background: #fff;
}
.cards-template-wapper{
    background: #d6dbe5;
    padding: 15px;
    border-radius: 3px;
}
.cards-template-item{
    margin-right: 15px;
    display: inline-block;
}
.tips{
    font-size: 12px;
}
.selected-wapper{
    font-size: 12px;
    border-top: 1px dashed #909399;
    margin-top: 15px;
    padding-top: 15px;
}
.selected-title{
    display: inline-block;
    width: 80px;
    text-align: left;
    color: #909399;
}
.selected-name{
    display: inline-block;
    margin-right: 20px;
}
.button-wapper{
    margin-left: 150px;
}
.button-wapper .el-button {
    width: 550px;
}
.upload-wapper{
    position: relative;
    display: inline-block;
    margin-right: 15px;
}
.upload-wapper input{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 210px;
    height: 100px;
    opacity: 0;
}
.image-slot span{
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    vertical-align: middle;
    display: inline-block;
    font-size: 12px;
    border: 1px dashed #909399;
    border-radius: 5px;
    color: #909399;
}
.notes {
    font-size: 12px;
    color: #F56C6C;
}
.label-title{
    color: #606266;
    font-size: 12px;
    position: relative;
}
.label-title::after{
    content: "*";
    color: #F56C6C;
    position:absolute;
    left: -10px;
}
.i-content-wapper{
    border: 1px solid #d6dbe5;
    border-bottom: none;
}
.i-content-query{
    padding: 15px;
}
.i-content-query .el-input{
    margin-right: 15px;
}
.info-label{
    font-size: 12px;
}
</style>